import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";

export const brands = ["Coca-Cola", "Thumsup", "Sprite", "Maaza", "Charged"];

export const ApproveBrandModal = ({
                               isOpen,
                               onClose,
                               onConfirm,
                               setBrand,
                               brand,
                               setChannelProgramme,
                               channelProgramme,
                           }) => {
    const [remark, setRemark] = useState('');




    return (
        <div className="fixed inset-0 z-1003 flex items-center justify-center bg-black/50" style={{zIndex: 99}}>
            <div className="absolute w-full max-w-md p-4 bg-white rounded-lg shadow dark:bg-gray-700">
                <button
                    type="button"
                    className="absolute top-3 right-2.5 text-gray-400 hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white rounded-lg p-1.5 text-sm"
                    onClick={onClose}
                >
                    <svg
                        aria-hidden="true"
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10
              8.586l4.293-4.293a1 1 0 111.414 1.414L11.414
              10l4.293 4.293a1 1 0 01-1.414
              1.414L10 11.414l-4.293
              4.293a1 1 0 01-1.414-1.414L8.586
              10 4.293 5.707a1 1 0 010-1.414z"
                        />
                    </svg>
                    <span className="sr-only">Close modal</span>
                </button>

                <div className="p-6 text-center">
                    <svg
                        aria-hidden="true"
                        className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 9v2m0 4h.01m-6.938
              4h13.856c1.54 0 2.502-1.667
              1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464
              0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>

                    <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400">
                        Brand: {brand || "UNDEFINED"}
                    </h3>
                    {/*<select*/}
                    {/*    className="mb-5 select select-bordered w-full"*/}
                    {/*    value={brand || ""}*/}
                    {/*    onChange={(e) => setBrand(e.target.value)}*/}
                    {/*>*/}
                    {/*    {brands.map((brandItem) => (*/}
                    {/*        <option key={brandItem} value={brandItem}>*/}
                    {/*            {brandItem}*/}
                    {/*        </option>*/}
                    {/*    ))}*/}
                    {/*</select>*/}

                    {/*<h3 className="text-lg font-normal text-gray-500 dark:text-gray-400">*/}
                    {/*    Channel Programme: {channelProgramme || ""}*/}
                    {/*</h3>*/}

                    {/*<select*/}
                    {/*    className="mb-5 select select-bordered w-full"*/}
                    {/*    value={channelProgramme || ""}*/}
                    {/*    onChange={(e) => setChannelProgramme(e.target.value)}*/}
                    {/*>*/}
                    {/*    {channelProgrammes.map(({ name }) => (*/}
                    {/*        <option key={name} value={name}>*/}
                    {/*            {name}*/}
                    {/*        </option>*/}
                    {/*    ))}*/}
                    {/*</select>*/}


                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        Please provide a Remark:
                    </h3>
                    <textarea
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Remark"
                    />
                    <br/>

                    <button
                        onClick={() => onConfirm(brand, remark)}
                        className="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                    >
                        Confirm - {brand}
                    </button>
                    <button
                        onClick={() => onClose()}
                        className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApproveBrandModal;
